import { Sort } from '@mode-switch/common';
import { validateArguments } from '../../SignatureValidation';
import * as Types from '../../Types';
import { ExprError } from '../ExprError';
import { ExprValue } from '../ExprValue';
export var RankFn;
(function (RankFn) {
    RankFn.Name = `RANK`;
    RankFn.Stage = "ANALYTIC";
    RankFn.Signature = `RANK(<expression>, [<order>])`;
    function make(_callName, _args, type, role) {
        return {
            name: RankFn.Name,
            stage: RankFn.Stage,
            data: { type, role },
            init,
            value,
        };
    }
    RankFn.make = make;
    function init() {
        return {
            ranks: undefined,
        };
    }
    RankFn.init = init;
    function value(context, values, orders) {
        const { state, frame: { index }, } = context;
        if (state.ranks === undefined) {
            const order = toOrder(orders ? orders[index] : 'desc');
            state.ranks = rankImpl(values, order, false);
        }
        const value = state.ranks[index];
        return {
            value,
            state,
        };
    }
    RankFn.value = value;
    function validate(callNode, callName, callArgs) {
        return validateArgs(RankFn.Name, RankFn.Signature, callNode, callName, callArgs);
    }
    RankFn.validate = validate;
})(RankFn || (RankFn = {}));
export var RankDenseFn;
(function (RankDenseFn) {
    RankDenseFn.Name = `RANK_DENSE`;
    RankDenseFn.Stage = "ANALYTIC";
    RankDenseFn.Signature = `RANK_DENSE(<expression>, [<order>])`;
    function make(_callName, _args, type, role) {
        return {
            name: RankDenseFn.Name,
            stage: RankDenseFn.Stage,
            data: { type, role },
            init,
            value,
        };
    }
    RankDenseFn.make = make;
    function init() {
        return {
            ranks: undefined,
        };
    }
    RankDenseFn.init = init;
    function value(context, values, orders) {
        const { state, frame: { index }, } = context;
        if (state.ranks === undefined) {
            const order = toOrder(orders ? orders[index] : 'desc');
            state.ranks = rankImpl(values, order, true);
        }
        const value = state.ranks[index];
        return {
            value,
            state,
        };
    }
    RankDenseFn.value = value;
    function validate(callNode, callName, callArgs) {
        return validateArgs(RankDenseFn.Name, RankDenseFn.Signature, callNode, callName, callArgs);
    }
    RankDenseFn.validate = validate;
})(RankDenseFn || (RankDenseFn = {}));
export function rankImpl(values, order, dense) {
    var _a;
    const indices = Sort.toSortedIndices(values, order);
    const ranks = Array.from(indices);
    let rank = 0;
    for (let index = 0, length = indices.length; index < length; index++) {
        const pIndex = (_a = indices[index - 1]) !== null && _a !== void 0 ? _a : -1;
        const pValue = values[pIndex];
        const cIndex = indices[index];
        const cValue = values[cIndex];
        if (!ExprValue.is(pValue, cValue)) {
            rank = dense
                ?
                    rank + 1
                :
                    index + 1;
        }
        ranks[cIndex] = rank;
    }
    return ranks;
}
function toOrder(s) {
    return (Sort.toOrder(s) ||
        -1);
}
function isValidOrder(s) {
    if (typeof s === 'string') {
        switch (s.toLowerCase()) {
            case 'asc':
            case 'desc': {
                return true;
            }
        }
    }
    return false;
}
function validateArgs(name, signature, callNode, callName, callArgs) {
    const tail = Math.max(1, callArgs.length);
    return validateArguments({
        meta: {
            name,
            signature,
            location: callNode.location,
        },
        arguments: [
            {
                stages: ["CONST", "AGGREGATE", "ANALYTIC"],
            },
            {
                type: "STRING",
                stages: ["CONST"],
                customValidation(node) {
                    if (Types.isStringLiteral(node) && !isValidOrder(node.value)) {
                        return [
                            new ExprError.InvalidArgument(name, signature, `invalid input. <order> must be one of ASC or DESC, ` +
                                `saw: ${node.value}`),
                        ];
                    }
                },
            },
        ].slice(0, tail),
    }, callArgs);
}
